import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import { StyledPageWrapper } from '../style';
import { SERVER_ERRORS } from '../../../constants';
import { MaterialIcon } from '../../MaterialIcon';
export var ErrorPageComponent = function (_a) {
    var _b = _a.onClick, onClick = _b === void 0 ? function () { return undefined; } : _b, _c = _a.statusCode, statusCode = _c === void 0 ? null : _c, _d = _a.description, description = _d === void 0 ? '' : _d;
    var _e = useState(''), descriptionError = _e[0], setDescription = _e[1];
    useEffect(function () {
        if (description) {
            setDescription(description);
        }
        else {
            var typeError = statusCode && SERVER_ERRORS[statusCode];
            if (typeError)
                setDescription(typeError.description);
        }
    }, [statusCode, description]);
    return (React.createElement(StyledPageWrapper, null,
        React.createElement("h1", null, descriptionError),
        React.createElement(Button, { style: { borderColor: 'transparent' }, onClick: onClick, icon: React.createElement(MaterialIcon, { type: "home" }) }, "Home")));
};
//# sourceMappingURL=Component.js.map